/* eslint-disable */
// import requestRawDev from '@/utils/requestRawDev'
import requestDev from '@/utils/requestDev'
import requestRaw from '@/utils/requestRaw'
import { APIReportPHP,APICoreV2 } from '@/utils/servicesApi'
const qs = require('qs')

export function broadcastMonitoring(data) {
    return requestRaw({
        url: APICoreV2() + '/omni/broadcast/monitoring',
        method: 'POST',
        data: data // { broadcast_ids: [] }
    })
}

export function broadcastStopMessage(data) {
    return requestRaw({
        url: APICoreV2() + '/omni/broadcast/stop_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function broadcastDeleteMessage(data) {
    return requestRaw({
        url: APICoreV2() + '/omni/broadcast/delete_selected',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function broadcastDraftMessage(data) {
    return requestRaw({
        url: APICoreV2() + '/omni/broadcast/draft',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function listBroadcastV2(params) {
    return requestDev({
        url: APIReportPHP() + '/message/broadcastv2',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listSmartReplyDetailMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/smartreply-monthly-detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listSmartReplysMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/smartreply-monthly',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listSmartReplysMonthlyExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/message/smartreply-monthly-excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listButtonsDetailMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/buttons-monthly-detail',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listButtonsMonthly(params) {
    return requestDev({
        url: APIReportPHP() + '/message/buttons-monthly',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listButtonsMonthlyExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/message/buttons-monthly-excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listBroadcast(params) {
    return requestDev({
        url: APIReportPHP() + '/message/broadcast',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listMessage(params) {
    return requestDev({
        url: APIReportPHP() + '/message/list',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listMessageExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/message/list-excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listBroadcastPrepare(params) {
    return requestDev({
        url: APIReportPHP() + '/message/list-broadcast-prepare',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listBroadcastImport(params) {
    return requestDev({
        url: APIReportPHP() + '/message/list-broadcast-import',
        method: 'POST',
        data: qs.stringify(params)
    })
}


// WEBPACK FOOTER //
// ./src/api/messageReport.js